import { createAction } from 'redux-actions';

export const GET_CONTEST_LEADERBOARD = 'GET_CONTEST_LEADERBOARD_YES_NO';
export const getContestLeaderboard = createAction(GET_CONTEST_LEADERBOARD);

export const GET_CONTEST_USER_LEADERBOARD = 'GET_CONTEST_USER_LEADERBOARD_YES_NO';
export const getContestUserLeaderboard = createAction(GET_CONTEST_USER_LEADERBOARD);

export const JOIN_CONTEST = 'JOIN_CONTEST_YES_NO';
export const joinContest = createAction(JOIN_CONTEST);

export const GET_MY_UPCOMING_MATCHES = 'GET_MY_UPCOMING_MATCHES_YES_NO';
export const getMyUpcomingMatches = createAction(GET_MY_UPCOMING_MATCHES);

export const GET_MY_LIVE_MATCHES = 'GET_MY_LIVE_MATCHES_YES_NO';
export const getMyLiveMatches = createAction(GET_MY_LIVE_MATCHES);

export const GET_MY_COMPLETED_MATCHES = 'GET_MY_COMPLETED_MATCHES_YES_NO';
export const getMyCompletedMatches = createAction(GET_MY_COMPLETED_MATCHES);

export const GET_MY_FIXTURE_JOINED_CONTEST_LIST = 'GET_MY_FIXTURE_JOINED_CONTEST_LIST_YES_NO';
export const getMyFixtureJoinedContest = createAction(GET_MY_FIXTURE_JOINED_CONTEST_LIST);

export const GET_MY_LIVE_JOINED_CONTEST_LIST = 'GET_MY_LIVE_JOINED_CONTEST_LIST_YES_NO';
export const getMyLiveJoinedContest = createAction(GET_MY_LIVE_JOINED_CONTEST_LIST);

export const GET_MY_RESULT_JOINED_CONTEST_LIST = 'GET_MY_RESULT_JOINED_CONTEST_LIST_YES_NO';
export const getMyResultJoinedContest = createAction(GET_MY_RESULT_JOINED_CONTEST_LIST);

export const FANTASY_MATCH_CLICK = 'FANTASY_MATCH_CLICK_YES_NO';
export const fantasyMatchClick = createAction(FANTASY_MATCH_CLICK);

export const MATCH_ITEM = 'MATCH_ITEM_YES_NO';
export const matchItem = createAction(MATCH_ITEM);

export const UPCOMING_MATCH_LIST = 'UPCOMING_MATCH_LIST_YES_NO';
export const getUpcomingMatchList = createAction(UPCOMING_MATCH_LIST);

export const GET_ALL_CONTEST_LIST = 'GET_ALL_CONTEST_LIST_YES_NO';
export const getAllContestList = createAction(GET_ALL_CONTEST_LIST);

export const GET_MATCH_PLAYER_LIST = 'GET_MATCH_PLAYER_LIST_YES_NO';
export const getPlayerList = createAction(GET_MATCH_PLAYER_LIST);

export const GET_CONTEST_DETAILS_BY_ID = 'GET_CONTEST_DETAILS_BY_ID_YES_NO';
export const getContestDetailsById = createAction(GET_CONTEST_DETAILS_BY_ID);

export const GET_MATCH_DETAILS_BY_ID = 'GET_MATCH_DETAILS_BY_ID_YES_NO';
export const getMatchDetailsById = createAction(GET_MATCH_DETAILS_BY_ID);

export const GET_CONTEST_LIST_BY_CONTEST_TYPE_ID = 'GET_CONTEST_LIST_BY_CONTEST_TYPE_ID_YES_NO';
export const getContestListByContestTypeId = createAction(GET_CONTEST_LIST_BY_CONTEST_TYPE_ID);

export const CONTEST_FILTER = 'CONTEST_FILTER_YES_NO';
export const updateContestFilter = createAction(CONTEST_FILTER);

export const GET_MY_TEAM_DETAILS_BY_TEAM_ID = 'GET_MY_TEAM_DETAILS_BY_TEAM_ID_YES_NO';
export const getMyTeamDetailsByTeamId = createAction(GET_MY_TEAM_DETAILS_BY_TEAM_ID);

export const GET_CONTEST_LIST_BY_CONTEST_TYPE = 'GET_CONTEST_LIST_BY_CONTEST_TYPE_YES_NO';
export const getContestListByContestType = createAction(GET_CONTEST_LIST_BY_CONTEST_TYPE);

export const GET_CONTEST_LIST_BY_CATEGORY = 'GET_CONTEST_LIST_BY_CATEGORY_YES_NO';
export const getContestListByCategory = createAction(GET_CONTEST_LIST_BY_CATEGORY);

export const GET_CONTEST_LIST_BY_CATEGORY_ID = 'GET_CONTEST_LIST_BY_CATEGORY_ID_YES_NO';
export const getContestListByCategoryId = createAction(GET_CONTEST_LIST_BY_CATEGORY_ID);

export const SET_MY_CONTEST_LIST = 'SET_MY_CONTEST_LIST_YES_NO';
export const setMyContestList = createAction(SET_MY_CONTEST_LIST);

export const SAVE_ANSWER_LIST = 'SAVE_ANSWER_LIST_YES_NO';
export const saveAnswerList = createAction(SAVE_ANSWER_LIST);

export const EDIT_ANSWER_LIST = 'EDIT_ANSWER_LIST_YES_NO';
export const editAnswerList = createAction(EDIT_ANSWER_LIST);

export const GET_ANSWER_LIST = 'GET_ANSWER_LIST_YES_NO';
export const getAnswerList = createAction(GET_ANSWER_LIST);

export const GET_MY_ANSWER_LIST = 'GET_MY_ANSWER_LIST_YES_NO';
export const getMyAnswerList = createAction(GET_MY_ANSWER_LIST);

export const GET_QUESTION_LIST = 'GET_QUESTION_LIST_YES_NO';
export const getQuestionList = createAction(GET_QUESTION_LIST);

export const GET_CONTEST_TYPES = 'GET_CONTEST_TYPES_YES_NO';
export const getContestTypes = createAction(GET_CONTEST_TYPES);

export const SET_CONTEST_TYPES = 'SET_CONTEST_TYPES_YES_NO';
export const setContestTypes = createAction(SET_CONTEST_TYPES);

export const SET_CONTEST_CATEGORIES = 'SET_CONTEST_CATEGORIES_YES_NO';
export const setContestCategories = createAction(SET_CONTEST_CATEGORIES);

export const CHECKED_MY_ANSWER = 'CHECKED_MY_ANSWER';
export const checkedMyAnswer = createAction(CHECKED_MY_ANSWER);

export const PREVIEW_ANSWER_LIST = 'PREVIEW_ANSWER_LIST_YES_NO';
export const previewAnswerList = createAction(PREVIEW_ANSWER_LIST);

export const SET_INITIAL_DATA = 'SET_INITIAL_DATA_YES_NO';
export const setInitialData = createAction(SET_INITIAL_DATA);

export const SET_ALL_CONTEST_LIST = 'SET_ALL_CONTEST_LIST_YES_NO';
export const setAllContestList = createAction(SET_ALL_CONTEST_LIST);
